module.exports = __webpack_public_path__ + "images/_/_/shared/images/ranking/3_1a3679281a92fab040589018ba5fc2be.png";